<template>
  <section class="bloc-text-video-full">
    <div class="bloc-text-video-full__wrapper">
      <div class="scroll-step js-scroll-show">
        <h2 class="bloc-text-video-full__title" v-html="content.title"></h2>
        <p class="bloc-text-video-full__text" v-html="content.text"></p>
      </div>

      <div class="bloc-text-video-full__media-ctn scroll-step js-scroll-show">
        <img v-if="content.img" :src="require(`@/${content.img}`)">
        <PlayerAutoVideoEmbed v-else-if="content.video && !content.video.video_provider" :content="content.video" />
        <PlayerAutoExternalEmbed v-else-if="content.video && content.video.video_provider" :content="content.video" />
      </div>
    </div>
  </section>
</template>

<script>
import PlayerAutoVideoEmbed from '@/components/PlayerAutoVideoEmbed.vue'
import PlayerAutoExternalEmbed from '@/components/PlayerAutoExternalEmbed.vue'

export default {
  name: 'TextMediaFull',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
  components: {
    PlayerAutoVideoEmbed,
    PlayerAutoExternalEmbed
  }
}
</script>

<style lang="scss">
  .bloc-text-video-full {
    width: 100vw;
    background: $th-white;
    padding: rem(45) 0 0;
    overflow: hidden;
    position: relative;

    @include media($from: small) {
      padding: rem(75) 0 0;
      width: 100%;
    }

    &__wrapper {
      margin: 0 auto;

      @include media($from: small) {
        width: 100%;
      }
    }

    &__media-ctn {
      width: 100%;
      height: grid_m(4, 3);
      display: block;
      position: relative;
      margin: 0 auto;
      margin-top: rem(60);

      @include media($from: small) {
        height: grid(6.85, 6);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__title {
      @include paragraph($type: 'extrabig-krug-hand', $color: $th-yellow, $uppercase: false);
      position: relative;
      text-align: center;
      display: block;
      font-style: italic;
      margin: 0 auto;
      width: grid_m(4.5, 4);
      
      @include media($from: small) {
        width: auto;
      }
    }

    &__text {
      @include paragraph($type: 'big', $color: $th-grey, $uppercase: false);
      position: relative;
      text-align: center;
      display: block;
      margin: 0 auto;
      margin-top: 30px;
      width: grid_m(4.5, 4);

      @include media($from: small) {
        width: grid(8, 7);
        margin: 0 auto;
        margin-top: 30px;
      }
    }
  }
</style>
